import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';

/**
 * A hook to manage filters for Algolia
 *
 * @returns An object containing the filters string (e.g. `name:"John" AND age:"18" OR age:"19"`) and the updateFilters function
 */
var useAlgoliaFilters = function useAlgoliaFilters() {
  var _useState = useState({}),
      filters = _useState[0],
      setFilters = _useState[1];

  var updateFilters = function updateFilters(index, options) {
    setFilters(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, index, options));
    });
  };

  var filtersString = Object.entries(filters).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return value.length ? "".concat(name, ":\"").concat(value.map(function (el, index) {
      return "".concat(index > 0 ? " OR ".concat(name, ":\"") : "").concat(el.value, "\"");
    }).join("")) : undefined;
  }).filter(Boolean).join(" AND ");
  return {
    updateFilters: updateFilters,
    filtersString: filtersString
  };
};

export default useAlgoliaFilters;